module.exports = __webpack_public_path__ + "assets/img/img75.84d6dafa.png";